var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluedelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.5H2.91667H12.25",
    stroke: "#4F46E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0827 3.50033V11.667C11.0827 11.9764 10.9598 12.2732 10.741 12.4919C10.5222 12.7107 10.2254 12.8337 9.91602 12.8337H4.08268C3.77326 12.8337 3.47652 12.7107 3.25772 12.4919C3.03893 12.2732 2.91602 11.9764 2.91602 11.667V3.50033M4.66602 3.50033V2.33366C4.66602 2.02424 4.78893 1.72749 5.00772 1.5087C5.22652 1.28991 5.52326 1.16699 5.83268 1.16699H8.16602C8.47544 1.16699 8.77218 1.28991 8.99097 1.5087C9.20977 1.72749 9.33268 2.02424 9.33268 2.33366V3.50033",
    stroke: "#4F46E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 6.41699V9.91699",
    stroke: "#4F46E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16602 6.41699V9.91699",
    stroke: "#4F46E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluedelete);
export default __webpack_public_path__ + "static/media/bluedelete.4ec8e1a7b911168821015f4e6e3c60e1.svg";
export { ForwardRef as ReactComponent };